// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"376":"0c932e53","452":"6e7eb527","673":"faa8af69","720":"641e5bdc","830":"de8bcff3","926":"711feb7a"}[chunkId] + ".css";
};